import { chooseRenderRevision, isRenderRevisionChoiceError } from '@/helpers/renderRevisionChoice';
import { Modal } from 'ant-design-vue';

const LAUNCH_IN_PROGRESS = 'launch_in_progress';

const STEP_NAMES = {
  neural: 'нейросеть',
  furniture: 'расстановка мебели',
  unreal: 'рендер',
  gltf: 'GLTF',
};

export const isLaunchInProgressError = (error) => error?.response?.status === 409
  && error?.response?.data?.code === LAUNCH_IN_PROGRESS;

const describeLaunch = ({ step, started_at: startedAt }) => {
  const stepName = STEP_NAMES[step] ?? step;

  if (!startedAt) return `«${stepName}»`;

  const time = new Date(startedAt).toLocaleString('ru-RU', { dateStyle: 'short', timeStyle: 'short' });

  return `«${stepName}», запуск от ${time}`;
};

const confirmRunningLaunch = (details) => new Promise((resolve) => {
  Modal.confirm({
    title: 'Предыдущий запуск ещё не завершён',
    content: `Сервисная планировка ещё в обработке: ${describeLaunch(details)}. `
      + 'Новый запуск создаст ещё одну сервисную планировку, а текущая обработка отработает впустую. '
      + 'Запустить всё равно?',
    okText: 'Запустить всё равно',
    cancelText: 'Отмена',
    centered: true,
    onOk: () => resolve(true),
    onCancel: () => resolve(false),
  });
});

export const launchWithConfirm = async (launch) => {
  let force = false;
  let choice = null;
  for (;;) {
    try {
      return await (choice ? launch(force, choice) : launch(force));
    } catch (error) {
      if (isLaunchInProgressError(error) && !force) {
        force = await confirmRunningLaunch(error.response.data);
        if (!force) return null;
      } else if (isRenderRevisionChoiceError(error)) {
        choice = await chooseRenderRevision(error.response.data);
        if (!choice) return null;
      } else {
        throw error;
      }
    }
  }
};
